import React, { useState, useEffect } from "react";
import "./Subscriptionplan.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProductList,
  createNewSubscription,
  fetchUserSubscriptionsById,
  cancelSubscription,
} from "../../../Services/Subscription/subscriptionApi";
import { capitalizeFirstLetter } from "../../../Utils/LetterCase";
import Modal from "react-bootstrap/Modal";
import { fetchCommunityDataByUserId } from "../../../Services/Community/CommunityAPI/communityApi";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

function SubscriptionPlans() {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const { data, loading } = useSelector((state) => state.fetchProductList);
  const subData = useSelector((state) => state.fetchUserSubscriptionsById.data);
  const [unitPrice, setUnitPrice] = useState();
  const [productId, setProductId] = useState("");
  const userId = localStorage.getItem("user_id");

  useEffect(() => {
    dispatch(fetchProductList());
    if (userId) {
      dispatch(fetchUserSubscriptionsById(userId));
    }
  }, [dispatch, userId]);

  const handleCancelSub = async (subscriptionId) => {
    try {
      const res = await dispatch(
        cancelSubscription({
          user_id: userId,
          subscription_id: subscriptionId,
        })
      ).unwrap();

      if (res.status === 200) {
        toast.success(res.message);
        dispatch(fetchUserSubscriptionsById(userId)); // Ensure the latest data is fetched
      }
    } catch (error) {
      toast.error("Failed to cancel subscription");
      console.error("Cancellation failed:", error);
    }
  };

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "75vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <CircularProgress size={50} sx={{ color: "#e55426" }} />
        </Box>
      </div>
    );

  return (
    <>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading">Subscription Plans</div>
          </div>
        </div>
        <div className="all-commmunities-table">
          {data?.data?.map((product) => (
            <div className="billing-box">
              <div className="billing_purchase d-flex align-items-center justify-content-between">
                <div className="billing-title allcommunities">
                  {/* Secured Document Portal & Compliance Monitoring (HOA
                                    Management) */}
                  {product.name}
                </div>
              </div>
              <div className="billing-subboxes">
                <div className="billing-innerwrap d-flex align-items-center justify-content-between">
                  <div className="billing-left-block">
                    Subscription Coverage
                  </div>
                  <div className="billing-right-block">Community</div>
                </div>
                <div className="billing-innerwrap d-flex align-items-center justify-content-between">
                  <div className="billing-left-block">Subscription Charge</div>
                  <div className="d-flex billing-input-block">
                    {/* <textarea className='billing-right-block charge'></textarea> */}
                    {/* <span className="input-group-text">$</span>
                                    <input type="number" className="form-control input-group billing-right-block charge" /> */}
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <input
                        type="number"
                        className="form-control"
                        value={product?.default_price?.unit_amount}
                        aria-label="Amount (to the nearest dollar)"
                      />
                    </div>
                  </div>
                </div>
                <div className="billing-innerwrap d-flex align-items-center justify-content-between">
                  <div className="billing-left-block">Billing Cycles</div>
                  <div className="billing-right-block">
                    {capitalizeFirstLetter(
                      product?.default_price?.recurring?.interval
                    )}
                    ly
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center"> <button
                className="bttn-upload rounded-pill"
                onClick={() => {
                  setModalShow(true);
                  setUnitPrice(product?.default_price?.unit_amount);
                  setProductId(product?.id);
                }}
              >
                Purchase
              </button></div>
            </div>
          ))}
        </div>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        unitPrice={unitPrice}
        productId={productId}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

function MyVerticallyCenteredModal(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = localStorage.getItem("user_id");
  const allcommunityByUserIdClaim = useSelector(
    (state) => state.fetchCommunityDataByUserId.data
  );
  const { data } = useSelector((state) => state.fetchProfileData?.data);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [quantity, setQuantity] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedCommunities, setSelectedCommunities] = useState([]);

  useEffect(() => {
    if (userId) {
      dispatch(
        fetchCommunityDataByUserId({
          userId: userId,
          activeTab: 1,
          page: 1,
          page_size: 10,
        })
      );
      dispatch(fetchProfileData(userId));
    }
  }, [dispatch, userId]); // Only fetch when userId changes

  useEffect(() => {
    if (Array.isArray(allcommunityByUserIdClaim?.data?.data)) {
      setOptions(allcommunityByUserIdClaim?.data?.data);
    } else {
      setOptions([]); // Ensure it's always an array
    }
  }, [allcommunityByUserIdClaim]); // Separate effect for setting options

  const handleSelect = (option) => {
    // setSelectedOptions((prev) =>
    //   prev.includes(option)
    //     ? prev.filter((item) => item !== option)
    //     : [...prev, option]
    // );
    setSelectedOptions(option);
  };

  useEffect(() => {
    // if (selectedOptions?.length > 0) {
    //   setQuantity(selectedOptions.length);
    //   setSelectedCommunities(selectedOptions.map((item) => item.community.id));
    // } else {
    //   setQuantity(0);
    //   setSelectedCommunities([]);
    // }
    if (selectedOptions) {
      setQuantity(1);
      setSelectedCommunities([selectedOptions?.community?.id]);
    } else {
      setQuantity(0);
      setSelectedCommunities([]);
    }
  }, [selectedOptions]);

  console.log("selectedOptions", selectedOptions)

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    console.log("userId:", userId);

    setIsSubmitting(true);
    try {
      const res = await dispatch(
        createNewSubscription({
          user_id: userId,
          product_id: props.productId,
          community_id: selectedCommunities,
        })
      );
      if (res) {
        toast.success("Subscription created successfully");
        props.onHide();
        setTimeout(() => {
          // console.log("res.checkout_url", res)
          window.location.href = res?.payload?.data?.checkout_session;
        }, 500);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false); // Unlock the button
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Create new subscription
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-3 gap-4">
          {options?.length ? <><h5>Select Community</h5>
            <div className="community-list">
              {options.map((option, index) => {
                const optionId = `community-${option.id || index}`;
                return (
                  <div key={optionId} className="form-check">
                    <input
                      id={optionId}
                      type="radio"
                      className="form-check-input"
                      // checked={selectedOptions.some(
                      //   (selected) => selected.id === option.id
                      // )}
                      checked={selectedOptions?.id === option.id}
                      onChange={() => handleSelect(option)}
                    />
                    <label htmlFor={optionId} className="form-check-label ms-2">
                      {option.community?.community_name || "Unnamed Community"}
                    </label>
                  </div>
                );
              })}
            </div></> : <p>At the moment, no community is available for you to subscribe to.</p>}


          {/* <div className="mt-3 selected-options">
            <h5>Selected communities:</h5>
            {selectedOptions.length > 0 ? (
              <ul>
                {selectedOptions.map((option, index) => (
                  <li key={index}>
                    {option.community?.community_name || "Unnamed Community"}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No communities selected</p>
            )}
          </div> */}
          {quantity ? (
            <div className="price-purchase">
              {props.unitPrice > 0 &&
                `Price: ${(props.unitPrice * quantity).toFixed(2)}`}
            </div>
          ) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="bttn-close"
          onClick={() => {
            props.onHide();
            setSelectedOptions([]);
          }}
        >
          Close
        </button>
        {options?.length ? <button className="bttn-upload" onClick={handleSubmit}>
          Pay
        </button> : null}

      </Modal.Footer>
    </Modal>
  );
}

export default SubscriptionPlans;
